import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import { getParameterByName, appVersionGraterThan, getQuery, redirectApp, envInfo, backApp, fix, tenMonthPregnant, getImUrl, openMNP, openCSQRCode, openCSQRCodeWithUnionId, openPregnantMaster1v1ByTypeAndImg, openPregnantMaster, getShopUrl, yzPaths, taobaoUrls, coachPregnancy, getEnvInfo, redirectBrowser, openPregnantIn9CyclesHelper, openDepositAlipay, openPregnantMaster1v1, openPregnantMaster1v1ByType,goBuyUtil,getCSQRCodeParams} from './utils'
import { getUserInfoFromLocal, getWechatUnionIdFromLocal } from './utils/token'
import VueCookies from 'vue-cookies'
import VueTouch from 'vue-touch'
import * as directives from './utils/directives'
import collect from './utils/collect'
import authorize from 'comps/authorize'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import wx from 'weixin-js-sdk'
import VueLazyload from 'vue-lazyload'
import { Dialog } from 'vant'
import './plugins/date'
import './plugins/vant'
// import 'amfe-flexible' // amfe-flexible 只适配移动端，在 PC 端使用会造成 “字体过大”
import './plugins/flexible' // lib-flexible 是 amfe-flexible 的旧版本，功能一样，不过限制了最大适配宽度540px（超过540px，root font 就不再变大了），更适合 PC 和 移动同时适配的情况
import '@/assets/css/reset.css'

Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VueCookies)

Vue.use(VueLazyload, {
  loading: require('./assets/images/activity/loading.png')
})

Vue.use(Dialog)
Vue.prototype.getQuery = getQuery
Vue.prototype.redirectApp = redirectApp
Vue.prototype.envInfo = envInfo
Vue.prototype.backApp = backApp
Vue.prototype.fix = fix
Vue.prototype.tenMonthPregnant = tenMonthPregnant
Vue.prototype.imUrl = getImUrl()
Vue.prototype.shopUrl = getShopUrl()
Vue.prototype.$openCSQRCode = openCSQRCode
Vue.prototype.$openMNP = openMNP
Vue.prototype.$openCSQRCodeWithUnionId = openCSQRCodeWithUnionId
Vue.prototype.$openPregnantMaster = openPregnantMaster
Vue.prototype.$openPregnantIn9CyclesHelper = openPregnantIn9CyclesHelper
Vue.prototype.$coachPregnancy = coachPregnancy
Vue.prototype.$collect = collect
Vue.prototype.$authorize = authorize.authorize
Vue.prototype.$wx = wx
Vue.prototype.$getParameterByName = getParameterByName
Vue.prototype.$appVersionGraterThan = appVersionGraterThan
Vue.prototype.$getUserInfoFromLocal = getUserInfoFromLocal
Vue.prototype.$getWechatUnionIdFromLocal = getWechatUnionIdFromLocal
Vue.prototype.$getEnvInfo = getEnvInfo
Vue.prototype.$redirectBrowser = redirectBrowser
Vue.prototype.$yzPaths = yzPaths()
Vue.prototype.$taobaoUrls = taobaoUrls()
Vue.prototype.$openDepositAlipay = openDepositAlipay
Vue.prototype.$openPregnantMaster1v1 = openPregnantMaster1v1
Vue.prototype.$openPregnantMaster1v1ByType = openPregnantMaster1v1ByType
Vue.prototype.$openPregnantMaster1v1ByTypeAndImg = openPregnantMaster1v1ByTypeAndImg
Vue.prototype.$goBuyUtil = goBuyUtil
Vue.prototype.$getCSQRCodeParams = getCSQRCodeParams
for (let k in directives) {
  Vue.directive(k, directives[k])
}

Vue.config.productionTip = (process.env.NODE_ENV === 'development')
Vue.config.devtools = (process.env.NODE_ENV === 'development')
// 设置cookie默认过期时间 1d 一天
Vue.$cookies.config('1d')
Vue.config.ignoredElements = ['wx-open-launch-app']

router.beforeEach((to, from, next) => {
  window.scroll(0,0)
  let authToken = to.query.authToken
  if (authToken) {
    Vue.$cookies.set('authToken', authToken)
  }
  // 只有 /task/task_detail 一个页面需要显示进度条
  if (to.path === '/task/task_detail') {
    NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})
NProgress.configure({ showSpinner: false })
// NProgress.configure({ trickle: false })

/**
 * 自定义指令 v-preventReClick，用于防止按钮快速重复点击时，事件多次触发
 */
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        // 直接给 span、div 等设置 disabled 无效，可以使用 pointer-events 属性 
        el.style.pointerEvents = 'none'
        setTimeout(() => {
          el.disabled = false
          el.style.pointerEvents = 'auto'
        }, binding.value || 2000)
      }
    })
  }
})

/// 全局事件总线。用于 发布/订阅 模式
var EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
